import { useEffect, useState } from "react";
import { makeRequestAuth, uploadFiles } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { RxCross2 } from "react-icons/rx";

export default function HomeServices() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");

    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState(null);

    const [confirmBox, setConfirmBox] = useState({
        open: false,
        id: null,
        status: false,
    });

    const [deleteBox, setDeleteBox] = useState({
    open: false,
    id: null,
    name: "",
});

const deleteService = async () => {
    try {
        const res = await makeRequestAuth(
            "post",
            "/admin/deleteServiceCategory",
            { id: deleteBox.id }
        );

        if (res?.error) {
            return showErrorToast(res.message || "Failed to delete service category");
        }

        showSuccessToast("Service category deleted permanently!");
        setDeleteBox({ open: false, id: null, name: "" });
        fecthData();
    } catch (error) {
        showErrorToast(error?.message || "Something went wrong!");
    }
};


    const fecthData = async () => {
        setLoading(true);
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/getListServiceCategory",
                {
                    pageNo: page,
                    size: limit,
                    search,
                    status,
                }
            );

            if (res?.error) {
                showErrorToast(res.message || "Failed to fetch services");
                setServices([]);
                return;
            }

            setServices(res?.data?.list || []);
            const totalCount = res?.data?.total || 0;
            setTotalPages(Math.ceil(totalCount / limit));

        } catch (error) {
            console.error("categoryError: ", error);
            showErrorToast(error?.message || "Something went wrong!");
            setServices([]);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fecthData();
    }, [page, search, status]);


    const uploadImage = async (file, setState) => {
        try {
            const res = await uploadFiles({
                fieldName: "file",
                files: [file],
            });

            if (res?.error) {
                return showErrorToast(res.message || "Image upload failed");
            }

            setState((prev) => ({
                ...prev,
                image: res.data.imageUrl,
            }));

        } catch (error) {
            showErrorToast(error?.message || "Upload error");
        }
    };

    const addPricingOption = () => {
        setEditData(prev => ({
            ...prev,
            pricingOptions: [
                ...(prev.pricingOptions || []),
                { title: "", price: "", image: "", description: "" }
            ]
        }));
    };

    const removePricingOption = (index) => {
        setEditData(prev => ({
            ...prev,
            pricingOptions: prev.pricingOptions.filter((_, i) => i !== index)
        }));
    };

    const handlePricingOptionChange = (index, field, value) => {
        const updatedOptions = [...editData.pricingOptions];
        updatedOptions[index][field] = value;
        setEditData(prev => ({ ...prev, pricingOptions: updatedOptions }));
    };

    const handleOptionImageChange = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const res = await uploadFiles({
                fieldName: "file",
                files: [file],
            });

            if (res?.error) {
                return showErrorToast(res.message || "Failed to upload image!");
            }

            handlePricingOptionChange(index, "image", res.data.imageUrl);
        } catch (error) {
            showErrorToast(error.message || "Image upload error");
        }
    };

    const updateService = async () => {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/editServiceCategory",
                {
                    id: editData._id,
                    name: editData.name,
                    image: editData.image,
                    pricingOptions: editData.pricingOptions || []
                }
            );

            if (res?.error) {
                return showErrorToast(res.message || "Failed to update service");
            }

            setShowEdit(false);
            fecthData();

        } catch (error) {
            showErrorToast(error?.message || "Update failed");
        }
    };

    const toggleServiceStatus = async () => {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/togelServiceCategory",
                {
                    id: confirmBox.id,
                }
            );

            if (res?.error) {
                return showErrorToast(res.message || "Status update failed");
            }

            setConfirmBox({ open: false, id: null, status: false });
            fecthData();

        } catch (error) {
            showErrorToast(error?.message || "Something went wrong");
        }
    };


    return (
        <div className="p-6">

            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-[#434646]">
                    Home Services
                </h2>
            </div>

            {/* FILTERS (UI only) */}
            <div className="bg-white rounded-2xl p-4 mb-6 shadow-sm border flex flex-wrap gap-4">
                <input
                    type="text"
                    placeholder="Search service..."
                    value={search}
                    onChange={(e) => {
                        setPage(1);
                        setSearch(e.target.value);
                    }}
                    className="border px-4 py-2 rounded-xl w-[220px] focus:outline-none focus:border-[#392DFF]"
                />

<select
    value={status}
    onChange={(e) => {
        setPage(1);
        setStatus(e.target.value);
    }}
    className="border px-4 py-2 rounded-xl focus:outline-none focus:border-[#392DFF]"
>
    <option value="">All Status</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
</select>

            </div>


            {/* 🔄 LOADING STATE */}
            {loading && (
                <div className="text-center py-20 text-gray-500">
                    Loading services...
                </div>
            )}

            {/* ❌ NO DATA STATE */}
            {!loading && services.length === 0 && (
                <div className="text-center py-20 text-gray-400">
                    No services found
                </div>
            )}

            {/* ✅ SERVICE CARDS */}
            {!loading && services.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {services.map((service) => (
                        <div
                            key={service._id}
                            className="bg-white rounded-2xl shadow p-4"
                        >
                            <img
                                src={service.image}
                                alt={service.name}
                                className="rounded-xl h-[160px] object-cover w-full"
                            />

                            <div className="mt-4">
                                <h3 className="font-semibold text-lg">
                                    {service.name}
                                </h3>

                                <p className="text-sm text-gray-500">
                                    Created: {new Date(service.createdAt).toLocaleDateString()}
                                </p>

                                <div className="flex justify-between items-center mt-4">
                                    <span
                                        className={`px-3 py-1 rounded-full text-sm ${service.isDisable === false
                                            ? "bg-green-100 text-green-600"
                                            : "bg-red-100 text-red-600"
                                            }`}
                                    >
                                        {service.isDisable === false ? "Enabled" : "Disabled"}
                                    </span>

                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => {
                                                setEditData(service);
                                                setShowEdit(true);
                                            }}
                                            className="px-3 py-1 border rounded-lg text-sm"
                                        >
                                            Edit
                                        </button>


                                        <button
    onClick={() =>
        setDeleteBox({
            open: true,
            id: service._id,
            name: service.name,
        })
    }
    className="px-3 py-1 border border-red-200 bg-red-50 text-red-600 rounded-lg text-sm font-semibold hover:bg-red-100 transition-all"
>
    Delete
</button>


                                        <button
                                            onClick={() =>
                                                setConfirmBox({
                                                    open: true,
                                                    id: service._id,
                                                    status: service.isDisable,
                                                })
                                            }
                                            className="px-3 py-1 border rounded-lg text-sm"
                                        >
                                            {service.isDisable === false ? "Disable" : "Enable"}
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* PAGINATION (UI only) */}
            {!loading && services.length > 0 && (
                <div className="flex justify-center items-center gap-4 mt-8">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage((prev) => prev - 1)}
                        className={`px-4 py-2 border rounded-lg ${page === 1 ? "text-gray-400 cursor-not-allowed" : ""
                            }`}
                    >
                        Prev
                    </button>

                    <span>
                        Page {page} / {totalPages}
                    </span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage((prev) => prev + 1)}
                        className={`px-4 py-2 border rounded-lg ${page === totalPages ? "text-gray-400 cursor-not-allowed" : ""
                            }`}
                    >
                        Next
                    </button>
                </div>
            )}

            {/* Edit Form */}
            {showEdit && editData && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-y-auto py-10">
                    <div className="bg-white rounded-2xl w-full max-w-2xl p-6">

                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-semibold">
                                Edit Home Service
                            </h3>
                            <button onClick={() => setShowEdit(false)}>
                                <RxCross2 size={24} />
                            </button>
                        </div>

                        <div className="space-y-6">
                            {/* NAME */}
                            <div>
                                <label className="block mb-2 font-medium">Service Name</label>
                                <input
                                    type="text"
                                    value={editData.name}
                                    onChange={(e) =>
                                        setEditData({ ...editData, name: e.target.value })
                                    }
                                    className="w-full border px-4 py-2 rounded-xl"
                                />
                            </div>

                            {/* IMAGE */}
                            <div>
                                <label className="block mb-2 font-medium">Service Image</label>
                                {editData.image && (
                                    <div className="relative mb-4 w-[200px]">
                                        <img
                                            src={editData.image}
                                            className="h-[140px] w-full object-cover rounded-xl"
                                        />
                                        <button
                                            onClick={() =>
                                                setEditData({ ...editData, image: "" })
                                            }
                                            className="absolute -top-2 -right-2 bg-red-500 text-white w-7 h-7 rounded-full flex items-center justify-center"
                                        >
                                            <RxCross2 size={16} />
                                        </button>
                                    </div>
                                )}

                                {!editData.image && (
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                            uploadImage(e.target.files[0], setEditData)
                                        }
                                        className="border px-4 py-2 rounded-xl w-full"
                                    />
                                )}
                            </div>

                            <hr />

                            {/* PRICING OPTIONS */}
                            <div>
                                <div className="flex justify-between items-center mb-4">
                                    <h4 className="font-semibold">Pricing Options</h4>
                                    <button
                                        type="button"
                                        onClick={addPricingOption}
                                        className="px-3 py-1 bg-green-500 text-white rounded-lg text-sm"
                                    >
                                        + Add Option
                                    </button>
                                </div>

                                <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2">
                                    {(editData.pricingOptions || []).map((option, index) => (
                                        <div key={index} className="border p-4 rounded-xl relative bg-gray-50">
                                            <button
                                                type="button"
                                                onClick={() => removePricingOption(index)}
                                                className="absolute top-2 right-2 text-red-500"
                                            >
                                                <RxCross2 size={20} />
                                            </button>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm mb-1">Title</label>
                                                    <input
                                                        type="text"
                                                        value={option.title}
                                                        onChange={(e) => handlePricingOptionChange(index, "title", e.target.value)}
                                                        className="w-full border px-3 py-1.5 rounded-lg text-sm"
                                                        required
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm mb-1">Price</label>
                                                    <input
                                                        type="number"
                                                        value={option.price}
                                                        onChange={(e) => handlePricingOptionChange(index, "price", e.target.value)}
                                                        className="w-full border px-3 py-1.5 rounded-lg text-sm"
                                                        required
                                                    />
                                                </div>
                                                <div className="md:col-span-2">
                                                    <label className="block text-sm mb-1">Description</label>
                                                    <textarea
                                                        value={option.description}
                                                        onChange={(e) => handlePricingOptionChange(index, "description", e.target.value)}
                                                        className="w-full border px-3 py-1.5 rounded-lg text-sm h-20"
                                                    />
                                                </div>
                                                <div className="md:col-span-2">
                                                    <label className="block text-sm mb-1">Option Image</label>
                                                    {option.image ? (
                                                        <div className="relative w-[120px] h-[80px]">
                                                            <img src={option.image} className="w-full h-full object-cover rounded-lg border" />
                                                            <button
                                                                type="button"
                                                                onClick={() => handlePricingOptionChange(index, "image", "")}
                                                                className="absolute -top-1.5 -right-1.5 bg-red-500 text-white rounded-full p-0.5"
                                                            >
                                                                <RxCross2 size={12} />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleOptionImageChange(index, e)}
                                                            className="w-full border px-3 py-1.5 rounded-lg text-sm"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {(editData.pricingOptions || []).length === 0 && (
                                        <p className="text-gray-400 text-sm italic text-center">No pricing options.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* ACTIONS */}
                        <div className="flex justify-end gap-3 mt-8">
                            <button
                                onClick={() => setShowEdit(false)}
                                className="px-4 py-2 border rounded-xl"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={updateService}
                                className="px-4 py-2 bg-[#392DFF] text-white rounded-xl font-medium"
                            >
                                Save Changes
                            </button>
                        </div>

                    </div>
                </div>
            )}


            {/* Enable Disable Conform */}
            {confirmBox.open && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl p-6 w-[350px] text-center">

                        <h3 className="text-lg font-semibold mb-3">
                            Are you sure?
                        </h3>

                        <p className="text-gray-500 mb-6">
                            Do you want to {confirmBox.status === false ? "disable" : "enable"} this service?
                        </p>

                        <div className="flex justify-center gap-4">
                            <button
                                onClick={() =>
                                    setConfirmBox({ open: false, id: null, status: false })
                                }
                                className="px-4 py-2 border rounded-lg"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    toggleServiceStatus(confirmBox.id);
                                    setConfirmBox({ open: false, id: null, status: false });
                                }}
                                className="px-4 py-2 bg-red-500 text-white rounded-lg"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Delete Confirmation Modal */}
{deleteBox.open && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl space-y-4">
            <h3 className="text-lg font-bold text-gray-900">Confirm Permanent Delete</h3>
            <p className="text-sm text-gray-600">
                Are you sure you want to permanently delete <span className="font-bold text-red-600">"{deleteBox.name}"</span>? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-3 pt-2">
                <button
                    onClick={() => setDeleteBox({ open: false, id: null, name: "" })}
                    className="px-4 py-2 border rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50"
                >
                    Cancel
                </button>
                <button
                    onClick={deleteService}
                    className="px-4 py-2 bg-red-600 text-white rounded-xl text-sm font-bold hover:bg-red-700 transition-all shadow-md"
                >
                    Delete Permanently
                </button>
            </div>
        </div>
    </div>
)}

        </div>
    );
}
